import { useLocation, useResolvedPath } from "@remix-run/react";

import { Step } from "~/modules/StateManager";
import { useStateManager } from "~/modules/StateManager.hooks";
import { isStepBefore } from "~/utils/getFlow";

export function useStepLinkState({ step }: { step: Step }) {
  const location = useLocation();
  const stateManager = useStateManager();

  const path = useResolvedPath(`./${step.pathname}`);

  const blockedByMissingTimeslot =
    stateManager.state.errors.timetable && !isStepBefore(stateManager.steps, step.id, "timetable");

  const isActive = location.pathname === path.pathname;
  const isEditable = !isActive && step.hasValue && !step.locked && !blockedByMissingTimeslot;

  return { isActive, isEditable };
}
